import * as React from "react";
import { forwardRef } from "react";
const SvgGuest = (props, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", fill: "none", viewBox: "0 0 11 11", ref, ...props }, /* @__PURE__ */ React.createElement("path", { fill: "#273238", stroke: "#fff", d: "M6.545.932a1.475 1.475 0 0 0-2.086 0L.932 4.46a1.475 1.475 0 0 0 0 2.086l3.527 3.528c.576.575 1.51.575 2.086 0l3.528-3.528a1.475 1.475 0 0 0 0-2.086z" }));
const ForwardRef = forwardRef(SvgGuest);
export { ForwardRef as ReactComponent };
